<p-table [value]="items()" [loading]="loading()">
  <ng-template pTemplate="header">
    <tr>
      <th>User ID</th>
      <th>Type</th>
      <th>Rating</th>
      <th>Description</th>
      <th>Last Asked</th>
      <th>Created At</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item [cTypedTableRow]="items()">
    <tr>
      <td><a class="underline text-blue-500" href="/users/{{item.userId}}" target="_blank">{{item.userId}}</a></td>
      <td>{{ item.type }}</td>
      <td>{{ item.rating }}</td>
      <td>{{ item.type === 'reviewed' ? item.description : '' }}</td>
      <td>{{ item.lastAsked | date:'M/d/yy, h:mm a' }}</td>
      <td>{{ item.createdAt | date:'M/d/yy, h:mm a' }}</td>
    </tr>
  </ng-template>
</p-table>
